/* eslint-disable */

export const usersReducerInitialState = {
  users: [],
};
